import {
  ChakraFlex,
  Text,
  CircularProgress,
  InfiniteScroll,
  ProviderAvatarBlock,
} from '@equip.health/ui';
import { SearchResultsProps } from './constants';

const LOADING_SIZE = 24;

const SearchResultsAdmin = ({
  handleSelect,
  id,
  isLoading,
  maxHeight,
  suggestions,
  totalOptionsCount = 0,
  fetchMoreProviders,
  highlightedIndex,
}: SearchResultsProps) => {
  if (isLoading && suggestions?.length === 0) {
    return (
      <ChakraFlex alignItems="center" justifyContent="center">
        <CircularProgress
          id={`${id}__loading-indicator`}
          isIndeterminate
          size={`${LOADING_SIZE}px`}
        />
      </ChakraFlex>
    );
  }
  return (
    <>
      {suggestions?.length > 0 ? (
        <InfiniteScroll
          dataLength={suggestions?.length}
          fetchData={fetchMoreProviders}
          hideCount
          id={id}
          marginTop="4px"
          maxHeight={maxHeight}
          showLoader={false}
          totalCount={totalOptionsCount}
        >
          {suggestions.map((suggestion: GetProviderByIdResponse, index) => {
            const {
              firstName,
              lastName,
              displayFirstName,
              displayLastName,
              providerTypeDetails,
              credentialsDetails,
              avatar,
              email,
            } = suggestion;

            const isDisplayName = displayFirstName && displayLastName;
            const legalName =
              firstName && lastName ? { firstName, lastName } : undefined;

            const displayName = isDisplayName
              ? { firstName: displayFirstName, lastName: displayLastName }
              : undefined;

            return (
              <ChakraFlex
                _hover={{
                  backgroundColor: 'secondary.5',
                  cursor: 'pointer',
                }}
                align="center"
                backgroundColor={
                  index === highlightedIndex
                    ? 'secondary.5'
                    : 'neutral.background.primary'
                }
                borderRadius="12px"
                color="unset"
                fontStyle="normal"
                id={`${id}__option-${suggestion.userId}`}
                key={suggestion.userId}
                onClick={() => handleSelect(suggestion)}
                padding="12px"
                role="listitem"
              >
                <ChakraFlex align="center" gap="10px">
                  <ProviderAvatarBlock
                    avatarUrl={avatar?.thumbnailUrl}
                    credentials={
                      credentialsDetails?.map((cred) => cred?.code) || []
                    }
                    displayName={displayName}
                    email={email}
                    id={`${id}__option-${suggestion.userId}__avatar-block`}
                    legalName={legalName}
                    providerTypeName={providerTypeDetails?.name}
                    shouldShowCredentials
                    shouldShowEmail
                    shouldShowLegalNameInParentheses
                    shouldShowPronouns
                    shouldShowProviderType
                    variant="standard"
                  />
                </ChakraFlex>
              </ChakraFlex>
            );
          })}
        </InfiniteScroll>
      ) : (
        <Text id={`${id}__no-results-text`}>No suggestions</Text>
      )}
    </>
  );
};

export default SearchResultsAdmin;
